export const formatJ1QueryValue = (value: any) => {
  if (Array.isArray(value)) {
    const values: string[] = value.map((v) => formatJ1QueryValue(v));
    return `(${values.join(' or ')})`;
  } else {
    return formatJ1QueryStringValue(value);
  }
};

function formatJ1QueryStringValue(value: any) {
  if (typeof value === 'string') {
    return `"${value}"`;
  } else {
    return `${value}`;
  }
}
